// Business hours use the same shape as Settings → Schedule:
// { day: 0-6 (Sunday = 0), active, seconds_start, seconds_end } with times in seconds since midnight

export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Monday first, matching the Schedule page
export const DAY_DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

const HOUR = 3600;

export const formatTime = (seconds) => {
    const hours = Math.floor(seconds / HOUR) % 24;
    const minutes = Math.floor((seconds % HOUR) / 60);
    const suffix = hours < 12 ? 'AM' : 'PM';
    const displayHours = hours % 12 || 12;
    return minutes ? `${displayHours}:${String(minutes).padStart(2, '0')} ${suffix}` : `${displayHours} ${suffix}`;
}

export const TIME_OPTIONS = Array.from({ length: 48 }, (_, index) => {
    const seconds = index * 1800;
    return { key: seconds, value: seconds, text: formatTime(seconds) };
}).concat({ key: 86399, value: 86399, text: '11:59 PM' });

const formatDayRange = (days) => {
    const names = days.map(day => DAY_NAMES[day]);
    return names.length > 2 ? `${names[0]} to ${names[names.length - 1]}` : names.join(' and ');
}

// e.g. "Monday to Friday, 9 AM to 5 PM; Saturday, 10 AM to 2 PM"
export const summarizeBusinessHours = (businessHours = []) => {
    const activeDays = DAY_DISPLAY_ORDER
        .map(day => businessHours.find(hours => hours.day === day))
        .filter(hours => hours?.active);
    if (!activeDays.length) {
        return 'Closed every day';
    }

    // Group consecutive days that share the same hours
    const groups = activeDays.reduce((result, hours) => {
        const lastGroup = result[result.length - 1];
        const previousDay = lastGroup?.days[lastGroup.days.length - 1];
        const isConsecutive = lastGroup && DAY_DISPLAY_ORDER.indexOf(hours.day) === DAY_DISPLAY_ORDER.indexOf(previousDay) + 1;
        if (isConsecutive && lastGroup.seconds_start === hours.seconds_start && lastGroup.seconds_end === hours.seconds_end) {
            lastGroup.days.push(hours.day);
        } else {
            result.push({ days: [hours.day], seconds_start: hours.seconds_start, seconds_end: hours.seconds_end });
        }
        return result;
    }, []);

    return groups.map(({ days, seconds_start, seconds_end }) => `${formatDayRange(days)}, ${formatTime(seconds_start)} to ${formatTime(seconds_end)}`).join('; ');
}
